let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("2YKNZ")).then(() => parcelRequire('9QCmd'));